/* ELLESANTI · tema V3 · la ricerca (studio «La ricerca» V1, 30/09/2026). Nessuna libreria. CTRL+G.
   1 · Pannello (sections/v3-cerca, gruppo overlay): si apre dall'icona dell'header, dal tasto «Cerca» della barra mobile, con «/» o ⌘K / Ctrl+K.
       Prima di scrivere: cercati spesso, visti di recente, momenti, frasi regalo. Mentre scrive: il dizionario delle intenzioni (righe nascoste
       della sezione, prime tre), i suggerimenti di Shopify (/search/suggest con la sezione v3-cerca-risposta) e il numero esatto
       (/search con v3-cerca-conta), dopo 2 lettere e 150 ms di pausa, con una memoria delle risposte. Frecce, Invio, Esc; il fuoco torna dov'era.
   2 · Pagina dei risultati (sections/v3-risultati): «Forse cerchi», regalo, schede per tipo, filtri, ordinamento e «Carica altri» nel browser.
   API: EllesantiV3.cerca.apri() · .chiudi() · .trova(parola, quante) · .intento(parola) · .prezzo(parola) */
(function () {
  'use strict';
  var H = document.documentElement;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var mqDesk = window.matchMedia ? window.matchMedia('(min-width: 1024px)') : { matches: true };
  var RM = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var E = window.EllesantiV3 = window.EllesantiV3 || {};

  function dec(s) { return String(s == null ? '' : s).replace(/&(#39|#x27|quot|lt|gt|amp);/g, function (m, k) { return { '#39': "'", '#x27': "'", quot: '"', lt: '<', gt: '>', amp: '&' }[k]; }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function parse(html) { return new DOMParser().parseFromString(html || '', 'text/html'); }
  function enc(s) { return encodeURIComponent(s); }
  /* minuscole, senza accenti, solo lettere e numeri separati da uno spazio */
  function norm(s) {
    s = String(s == null ? '' : s).toLowerCase();
    if (s.normalize) s = s.normalize('NFD');
    s = s.replace(/[^\x00-\x7f]/g, function (c) { var k = c.charCodeAt(0); return (k >= 0x300 && k <= 0x36f) ? '' : ' '; });
    return s.replace(/[^a-z0-9]+/g, ' ').trim();
  }
  /* come norm, ma un carattere per carattere (serve a mettere in evidenza la parte che manca) */
  function flat(s) {
    return Array.prototype.map.call(String(s), function (c) {
      var d = (c.normalize ? c.normalize('NFD') : c).charAt(0).toLowerCase();
      return /[a-z0-9]/.test(d) ? d : ' ';
    }).join('');
  }
  function evid(t, qn) {
    if (!qn) return esc(t);
    var f = flat(t);
    if (f.indexOf(qn) !== 0 || qn.length >= t.length) return esc(t);
    return esc(t.slice(0, qn.length)) + '<b>' + esc(t.slice(qn.length)) + '</b>';
  }
  function splitK(s) { return String(s || '').split(/[|,\n]/).map(norm).filter(Boolean); }

  /* ================================================================ dizionario delle intenzioni */
  var D = { rows: [], reg: [], t: {}, prezzo: null, pronto: false };
  function initDiz(cs) {
    var dati = {};
    try { dati = JSON.parse(($('[data-e-cs-dati]', cs) || {}).textContent || '{}'); } catch (e) { dati = {}; }
    D.t = dati.t || {};
    Object.keys(D.t).forEach(function (k) { D.t[k] = dec(D.t[k]); });
    D.reg = splitK(dati.reg);
    D.b2b = !!dati.b2b;
    D.rows = [];
    D.prezzo = null;
    $$('[data-e-cs-pool] .e-cs__d', cs).forEach(function (a) {
      var g = a.getAttribute('data-g');
      if (g === 'prezzo') { D.prezzo = a; return; }
      var t = (($('.e-cs__dt', a) || {}).textContent || '').trim();
      var k = splitK(a.getAttribute('data-k'));
      var tn = norm(t);
      if (tn && k.indexOf(tn) < 0) k.push(tn);
      D.rows.push({ el: a, g: g, t: t, k: k, p: +(a.getAttribute('data-p') || 0), u: a.getAttribute('href') });
    });
    D.pronto = true;
  }
  function punti(qn, toks, kws) {
    var best = 0, pad = ' ' + qn + ' ', last = toks[toks.length - 1] || '';
    for (var i = 0; i < kws.length; i++) {
      var k = kws[i], s = 0;
      if (qn === k) s = 300 + k.length;
      else if (pad.indexOf(' ' + k + ' ') > -1) s = 200 + k.length;
      else if (qn.length >= 3 && k.indexOf(qn) === 0) s = 150 + qn.length;
      else if (toks.length > 1 && last.length >= 3 && (' ' + k).indexOf(' ' + last) > -1) s = 60 + last.length;
      if (s > best) best = s;
    }
    return best;
  }
  /* il prezzo scritto a parole: «sotto 50», «fino a 70 euro», «oltre 100», «da 50 a 100», «under 80» */
  var RX = [
    ['tra', /(?:^| )(?:da|tra|fra|between|from) (\d+)(?: euro| eur)? (?:e|a|to|and) (\d+)(?: euro| eur)?(?= |$)/],
    ['fino', /(?:^| )(?:sotto|meno di|fino a|entro|massimo|max|under|below|less than|up to) (?:i |ai |a )?(\d+)(?: euro| eur)?(?= |$)/],
    ['da', /(?:^| )(?:oltre|piu di|sopra|almeno|over|above|more than) (?:i |a )?(\d+)(?: euro| eur)?(?= |$)/],
    ['fino', /(?:^| )(\d+) (?:euro|eur)(?= |$)/]
  ];
  function prezzo(q) {
    var qn = norm(q);
    for (var i = 0; i < RX.length; i++) {
      var m = RX[i][1].exec(qn);
      if (!m) continue;
      var a = '', b = '';
      if (RX[i][0] === 'tra') { a = +m[1]; b = +m[2]; if (a > b) { var x = a; a = b; b = x; } }
      else if (RX[i][0] === 'fino') b = +m[1];
      else a = +m[1];
      return { k: RX[i][0], a: a, b: b, via: m[0], resto: (qn.slice(0, m.index) + ' ' + qn.slice(m.index + m[0].length)).replace(/ +/g, ' ').trim() };
    }
    return null;
  }
  function senzaPrezzo(q) { var p = prezzo(q); return p ? p.resto : q; }
  function trova(q, max) {
    if (!D.pronto) return [];
    var qn = norm(senzaPrezzo(q)), toks = qn.split(' ').filter(Boolean);
    if (qn.length < 2) return [];
    var out = [];
    D.rows.forEach(function (r) { var s = punti(qn, toks, r.k); if (s > 0) out.push({ r: r, s: s + r.p }); });
    out.sort(function (a, b) { return b.s - a.s; });
    var seen = {}, res = [];
    out.forEach(function (o) { if (res.length >= (max || 3) || seen[o.r.u]) return; seen[o.r.u] = 1; res.push(o.r); });
    return res;
  }
  /* la parola che si sta scrivendo, completata con il dizionario («caucc» → «caucciù»): serve quando Shopify non trova
     il pezzo di parola (le prime lettere valgono per titoli, tipi e varianti, non per le descrizioni) */
  function completa(q) {
    if (!D.pronto) return '';
    var qn = norm(senzaPrezzo(q)), best = null;
    if (qn.length < 3) return '';
    D.rows.forEach(function (r) {
      var tn = norm(r.t);
      if (tn.length > qn.length && tn.indexOf(qn) === 0 && (!best || r.p > best.p || (r.p === best.p && tn.length < best.n))) best = { t: r.t.toLowerCase(), p: r.p, n: tn.length };
    });
    if (best) return best.t;
    D.rows.forEach(function (r) {
      r.k.forEach(function (k) {
        if (k.length > qn.length && k.indexOf(qn) === 0 && (!best || r.p > best.p || (r.p === best.p && k.length < best.n))) best = { t: k, p: r.p, n: k.length };
      });
    });
    return best ? best.t : '';
  }
  function intento(q) {
    var qn = norm(q);
    if (qn.length < 3 || !D.reg.length) return false;
    var pad = ' ' + qn + ' ', toks = qn.split(' '), last = toks[toks.length - 1];
    for (var i = 0; i < D.reg.length; i++) {
      var k = D.reg[i];
      if (pad.indexOf(' ' + k + ' ') > -1) return true;
      if (last.length >= 4 && k.indexOf(last) === 0 && k.indexOf(' ') < 0) return true;
    }
    return false;
  }
  /* la riga del prezzo: su una categoria («Orecchini fino a 50 €») o su tutti i gioielli */
  function rigaPrezzo(pz, base) {
    if (!pz || !D.prezzo) return null;
    var el = D.prezzo.cloneNode(true), t = D.t;
    var fr = pz.k === 'tra' ? (t.p_tra || '').replace('[a]', pz.a).replace('[b]', pz.b) : pz.k === 'fino' ? (t.p_fino || '').replace('[n]', pz.b) : (t.p_da || '').replace('[n]', pz.a);
    var u = base ? base.u : D.prezzo.getAttribute('href');
    u = u.split('#')[0];
    var ps = [];
    if (pz.a !== '') ps.push('filter.v.price.gte=' + pz.a);
    if (pz.b !== '') ps.push('filter.v.price.lte=' + pz.b);
    el.setAttribute('href', u + (u.indexOf('?') > -1 ? '&' : '?') + ps.join('&'));
    var dt = $('.e-cs__dt', el);
    if (dt) dt.textContent = ((base ? base.t : t.p_tutti) + ' ' + fr).trim();
    return el;
  }
  function righe(q, max) {
    var dest = trova(q, max), pz = prezzo(q), out = [], qn = norm(senzaPrezzo(q));
    if (pz) {
      var base = null;
      dest.forEach(function (r) { if (!base && (r.g === 'tipo' || r.g === 'materiale')) base = r; });
      var rp = rigaPrezzo(pz, base);
      if (rp) out.push(rp);
    }
    dest.forEach(function (r) {
      if (out.length >= (max || 3)) return;
      var el = r.el.cloneNode(true), dt = $('.e-cs__dt', el);
      if (dt) dt.innerHTML = evid(r.t, qn);
      out.push(el);
    });
    return out;
  }

  /* ================================================================ pannello */
  var CS = null, S = {};
  function testo(k) { return D.t[k] || ''; }
  function cnt(n) { return n === 1 ? testo('g1') : testo('gn').replace('[n]', n); }
  function typing(el) { return el && (el.isContentEditable || /^(input|textarea|select)$/i.test(el.tagName)); }
  function risultati(q) { return (CS.getAttribute('data-cerca') || ROOT + 'search') + '?q=' + enc(q) + '&type=product,page&options%5Bprefix%5D=last'; }

  function initPannello(scope) {
    var cs = (scope && scope.matches && scope.matches('[data-e-cs]')) ? scope : $('[data-e-cs]', scope || document);
    if (!cs || cs._e) return;
    cs._e = true;
    CS = cs;
    initDiz(cs);
    S = {
      p: $('.e-cs__p', cs), q: $('[data-e-cs-q]', cs), b: $('[data-e-cs-b]', cs), v: $('[data-e-cs-v]', cs), r: $('[data-e-cs-r]', cs),
      clr: $('[data-e-cs-clr]', cs), live: $('[data-e-cs-live]', cs), int: $('[data-e-cs-int]', cs), rc: $('[data-e-cs-rc]', cs),
      dl: $('[data-e-cs-dl]', cs), parole: $('[data-e-cs-parole]', cs), pagine: $('[data-e-cs-pagine]', cs), cards: $('[data-e-cs-cards]', cs),
      glab: $('[data-e-cs-glab]', cs), rn: $('[data-e-cs-rn]', cs), rf: $('[data-e-cs-rf]', cs), tutti: $('[data-e-cs-tutti]', cs), tt: $('[data-e-cs-tt]', cs),
      vz: $('[data-e-cs-vz]', cs), no: $('[data-e-cs-no]', cs), not: $('[data-e-cs-not]', cs), rl: $('[data-e-cs-rl]', cs),
      visti: $('[data-e-cs-visti]', cs), vl: $('[data-e-cs-vl]', cs),
      open: false, back: null, timer: 0, ctrl: null, cache: {}, scelti: null, vistiOk: false, n: 0
    };
    if (!S.q) return;
    S.q.addEventListener('input', function () { aggiorna(false); });
    S.q.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { var o = opts(); if (o.length) { e.preventDefault(); o[0].focus(); } }
    });
    $('[data-e-cs-form]', cs).addEventListener('submit', function (e) {
      if (!norm(S.q.value)) { e.preventDefault(); S.q.focus(); }
    });
    cs.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-e-cs-x]')) { e.preventDefault(); chiudi(); return; }
      if (t.closest('[data-e-cs-clr]')) { S.q.value = ''; aggiorna(true); S.q.focus(); return; }
      var w = t.closest('[data-e-cs-parola]');
      if (w) { S.q.value = w.getAttribute('data-e-cs-parola'); aggiorna(true); S.q.focus(); return; }
      var az = t.closest('.e-cs__d[data-az]');
      if (az && E.guida && E.guida.apri) {
        var k = az.getAttribute('data-az') === 'guida-bracciali' ? 'bracciali' : 'anelli';
        if (!E.guida.ha || E.guida.ha(k)) { e.preventDefault(); chiudi(true); E.guida.apri(k, {}); }
      }
    });
    cs.addEventListener('keydown', tasti);
    window.addEventListener('resize', function () { if (S.open) pos(); });
    /* chi passa al menu dell'header lascia la ricerca */
    $$('[data-e-voce], [data-e-burger], [data-e-aiuto-btn]').forEach(function (b) {
      if (b._eCs) return;
      b._eCs = true;
      b.addEventListener('mouseenter', function () { if (S.open && mqDesk.matches) chiudi(true); });
      b.addEventListener('click', function () { if (S.open) chiudi(true); }, true);
    });
  }

  function opts() {
    return $$('[data-e-cs-opt]', S.p).filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }
  function tasti(e) {
    if (e.key === 'Escape') {
      if (H.classList.contains('e-lock')) return;
      e.preventDefault();
      chiudi();
      return;
    }
    if (e.key === 'Tab') {
      var f = $$('a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"])', S.p).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var i = f.indexOf(document.activeElement);
      if (e.shiftKey && (i <= 0)) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
      return;
    }
    if (e.target === S.q) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      var o = opts(), j = o.indexOf(e.target);
      if (j < 0) return;
      e.preventDefault();
      if (e.key === 'ArrowUp') { if (j === 0) S.q.focus(); else o[j - 1].focus(); }
      else if (j < o.length - 1) o[j + 1].focus();
      return;
    }
    if ((e.key.length === 1 || e.key === 'Backspace') && !e.metaKey && !e.ctrlKey && !e.altKey && e.key !== ' ') S.q.focus();
  }

  function pos() {
    var sec = $('.e-hd-section'), hd = $('[data-e-hd]'), top = 0, was = false;
    if (sec) {
      was = sec.classList.contains('is-hidden');
      sec.classList.remove('is-hidden');
      H.classList.remove('e-hd-hidden');
    }
    /* il riquadro dell'header, non della sezione: in homepage la sezione è alta 0 e l'header sta sopra la foto */
    if (hd) top = was ? hd.offsetHeight : Math.max(0, Math.round(hd.getBoundingClientRect().bottom));
    CS.style.setProperty('--e-cs-top', top + 'px');
    var bb = $('.e-bbar'), bh = 0;
    if (bb && getComputedStyle(bb).display !== 'none') bh = Math.round(bb.getBoundingClientRect().height);
    CS.style.setProperty('--e-cs-bb', bh + 'px');
  }
  function header(on) {
    var hd = $('[data-e-hd]');
    if (!hd) return;
    if (on) hd.classList.add('is-solid');
    else { try { window.dispatchEvent(new Event('scroll')); } catch (e) {} }
  }
  function apri(from) {
    if (!CS) return;
    if (S.open) { S.q.focus(); return; }
    S.back = from || document.activeElement;
    var dim = $('[data-e-dim].is-on');
    if (dim) dim.click();
    if (H.classList.contains('e-drawer-open')) { var x = $('[data-e-drawer] [data-e-close]'); if (x) x.click(); }
    pos();
    CS.hidden = false;
    S.open = true;
    H.classList.add('e-cerca-open');
    header(true);
    S.q.placeholder = mqDesk.matches ? S.q.getAttribute('data-ph') : S.q.getAttribute('data-ph-m');
    var q0 = CS.getAttribute('data-q');
    if (!S.q.value && q0) S.q.value = q0;
    try { S.q.focus({ preventScroll: true }); } catch (e) { S.q.focus(); }
    void CS.offsetWidth;
    CS.classList.add('is-open');
    $$('[data-e-cerca-apri]').forEach(function (a) { a.setAttribute('aria-expanded', 'true'); });
    aggiorna(true);
    if (S.q.value) { try { S.q.select(); } catch (e) {} }
    visti();
    disegna($$('.e-cs__v .e-segno', CS), 140);
  }
  /* i segni si disegnano uno dopo l'altro (con il movimento ridotto compaiono subito) */
  function disegna(list, dopo) {
    list.forEach(function (s, k) {
      if (RM || !H.classList.contains('e-anim')) { s.classList.add('is-drawn'); return; }
      s.classList.remove('is-drawn');
      setTimeout(function () { s.classList.add('is-drawn'); }, (dopo || 0) + k * 40);
    });
  }
  function chiudi(quiet) {
    if (!CS || !S.open) return;
    S.open = false;
    CS.classList.remove('is-open');
    H.classList.remove('e-cerca-open');
    $$('[data-e-cerca-apri]').forEach(function (a) { a.setAttribute('aria-expanded', 'false'); });
    if (S.ctrl) { try { S.ctrl.abort(); } catch (e) {} }
    clearTimeout(S.timer);
    setTimeout(function () { if (!S.open) CS.hidden = true; }, RM ? 0 : 280);
    header(false);
    var b = S.back;
    S.back = null;
    if (!quiet && b && b.focus && document.contains(b)) { try { b.focus({ preventScroll: true }); } catch (e) {} }
  }

  function get(u, opt) {
    return fetch(u, opt).then(function (r) { return r.ok ? r.text() : ''; });
  }
  function leggi(html) {
    var d = parse(html), box = $('[data-e-csr]', d);
    var part = function (k) { var x = box && $('[data-r="' + k + '"]', box); return x ? x.innerHTML.trim() : ''; };
    var n = box && $('[data-r="n"]', box);
    return { prodotti: part('prodotti'), parole: part('parole'), pagine: part('pagine'), n: n ? +n.getAttribute('data-n') : 0 };
  }
  function chiedi(q, reg) {
    var key = (reg ? 'R|' : '') + q;
    if (S.cache[key]) return Promise.resolve(S.cache[key]);
    if (S.ctrl) { try { S.ctrl.abort(); } catch (e) {} }
    S.ctrl = window.AbortController ? new AbortController() : null;
    var opt = { credentials: 'same-origin' };
    if (S.ctrl) opt.signal = S.ctrl.signal;
    var sug = CS.getAttribute('data-sug') || ROOT + 'search/suggest';
    var u1 = sug + '?q=' + enc(q) + '&resources%5Btype%5D=product,query,page&resources%5Blimit%5D=10&resources%5Blimit_scope%5D=each&resources%5Boptions%5D%5Bunavailable_products%5D=last&section_id=v3-cerca-risposta';
    var p1 = get(u1, opt).then(leggi);
    var p2;
    if (reg) {
      var su = CS.getAttribute('data-scelti');
      p2 = S.scelti !== null || !su ? Promise.resolve(S.scelti || '') : get(su + (su.indexOf('?') > -1 ? '&' : '?') + 'section_id=v3-cerca-risposta', opt).then(function (h) { S.scelti = leggi(h).prodotti; return S.scelti; });
    } else {
      var cu = (CS.getAttribute('data-cerca') || ROOT + 'search') + '?q=' + enc(q) + '&type=product&options%5Bprefix%5D=last&section_id=v3-cerca-conta';
      p2 = get(cu, opt).then(function (h) { var m = /data-e-cerca-n="(\d+)"/.exec(h); return m ? +m[1] : -1; });
    }
    return Promise.all([p1, p2]).then(function (a) {
      var r = a[0];
      if (reg) r.scelti = a[1]; else r.tot = a[1];
      S.cache[key] = r;
      return r;
    });
  }

  function aggiorna(subito) {
    var q = S.q.value, qn = norm(q);
    S.clr.hidden = !q;
    clearTimeout(S.timer);
    if (qn.length < 2) {
      S.v.hidden = false;
      S.r.hidden = true;
      S.live.textContent = '';
      return;
    }
    S.v.hidden = true;
    S.r.hidden = false;
    var dest = righe(q, 3), reg = intento(q), qs = senzaPrezzo(q);
    S.dl.innerHTML = '';
    dest.forEach(function (el) { S.dl.appendChild(el); });
    disegna($$('.e-segno', S.dl), 60);
    gruppo('dest', dest.length > 0);
    if (reg && S.int.hidden) disegna($$('.e-segno', S.int), 80);
    S.int.hidden = !reg;
    gruppo('aiuto', reg);
    if (norm(qs).length < 2 && !reg) { mostra({ prodotti: '', parole: '', pagine: '', n: 0, tot: 0 }, q, dest.length, reg); return; }
    S.r.classList.add('is-loading');
    S.timer = setTimeout(function () {
      chiedi(reg ? q : qs, reg).then(function (res) {
        if (S.q.value !== q) return;
        var alt = !reg && !res.n ? completa(q) : '';
        if (alt && norm(alt) !== norm(qs)) {
          return chiedi(alt, false).then(function (r2) {
            if (S.q.value !== q) return;
            if (r2.n) mostra(r2, q, dest.length, reg, alt); else mostra(res, q, dest.length, reg);
          });
        }
        mostra(res, q, dest.length, reg);
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (S.q.value === q) mostra({ prodotti: '', parole: '', pagine: '', n: 0, tot: -1 }, q, dest.length, reg);
      });
    }, subito ? 0 : 150);
  }
  function gruppo(k, on) { var g = $('[data-e-cs-g="' + k + '"]', S.r); if (g) g.hidden = !on; }
  function mostra(res, q, nd, reg, alt) {
    var t = D.t, n = res.n || 0, tot = res.tot;
    if (tot >= 0 && tot < n) tot = n;
    S.r.classList.remove('is-loading');
    S.parole.innerHTML = res.parole || '';
    gruppo('parole', !!res.parole);
    S.pagine.innerHTML = res.pagine || '';
    gruppo('pagine', !!res.pagine);
    var cards = reg ? (res.scelti || '') : (res.prodotti || '');
    S.cards.innerHTML = cards;
    $$('.e-card__img', S.cards).forEach(function (a) { a.setAttribute('data-e-cs-opt', ''); });
    var nc = $$('.e-card', S.cards).length;
    S.glab.textContent = reg ? testo('scelti') : testo('gioielli');
    S.rn.textContent = reg ? testo('scelti_nota') : (nc && tot > 0 ? testo('range').replace('[k]', nc).replace('[n]', tot) : '');
    var qs = alt || senzaPrezzo(q);
    var none = !reg && nc === 0 && !res.parole && !res.pagine && nd === 0;
    S.no.hidden = !none;
    S.rc.hidden = none;
    if (none) S.not.textContent = testo('nessuno').replace('[q]', q.trim());
    var vuoto = !reg && nc === 0 && !none;
    S.vz.hidden = !vuoto;
    if (vuoto) S.vz.textContent = testo('nessuno').replace('[q]', q.trim());
    var qsn = norm(qs).length >= 2;
    S.rf.hidden = reg || nc === 0 || !qsn;
    if (!S.rf.hidden) {
      S.tutti.setAttribute('href', risultati(qs.trim()));
      var tn = tot > 0 ? tot : nc;
      S.tt.textContent = (tn === 1 ? testo('vedi_1') : testo('vedi_n').replace('[n]', cnt(tn))).replace('[q]', qs.trim());
    }
    S.rc.classList.toggle('is-solo', !S.rl.querySelector('[data-e-cs-g]:not([hidden])'));
    var ann = none ? S.not.textContent : (tot > 0 ? testo('titolo').replace('[n]', cnt(tot)).replace('[q]', qs.trim()) : '');
    S.live.textContent = ann;
    if (E.init) { try { E.init(S.cards); } catch (e) {} }
    $$('.e-segno', S.cards).forEach(function (s) { s.classList.add('is-drawn'); });
  }

  /* visti di recente (solo nel browser, con il consenso alle preferenze: li scrive v3-head nella scheda) */
  function visti() {
    if (S.vistiOk || !S.visti) return;
    S.vistiOk = true;
    var list = [];
    try { list = JSON.parse(localStorage.getItem('e-visti') || '[]'); } catch (e) { list = []; }
    if (!Array.isArray(list) || !list.length) return;
    list = list.slice(0, 3);
    Promise.all(list.map(function (h) {
      return fetch(ROOT + 'products/' + enc(h) + '?section_id=v3-cerca-visto', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (arr) {
      var html = arr.map(function (h) { var a = $('.e-cs__vr', parse(h)); return a ? a.outerHTML : ''; }).join('');
      if (html) { S.vl.innerHTML = html; S.visti.hidden = false; }
    });
  }

  /* aperture: icona dell'header, tasto della barra mobile, «/», ⌘K / Ctrl+K; Esc chiude anche se il fuoco non è nel pannello */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-e-cerca-apri]');
    if (!a || !CS) return;
    e.preventDefault();
    if (S.open) chiudi(); else apri(a);
  });
  document.addEventListener('keydown', function (e) {
    if (!CS) return;
    var k = (e.key || '').toLowerCase();
    if ((e.metaKey || e.ctrlKey) && k === 'k' && !H.classList.contains('e-lock')) { e.preventDefault(); if (S.open) S.q.focus(); else apri(); return; }
    if (!S.open && e.key === '/' && !typing(e.target) && !H.classList.contains('e-lock')) { e.preventDefault(); apri(); return; }
    if (S.open && e.key === 'Escape' && !H.classList.contains('e-lock') && !CS.contains(e.target)) { chiudi(); }
  });

  /* ================================================================ pagina dei risultati */
  function initRisultati(scope) {
    var rs = (scope && scope.matches && scope.matches('[data-e-rs]')) ? scope : $('[data-e-rs]', scope || document);
    if (!rs || rs._e) return;
    rs._e = true;
    var q = rs.getAttribute('data-q') || '';

    /* il campo: la crocetta svuota */
    var qi = $('[data-e-rs-q]', rs), qx = $('[data-e-rs-clr]', rs);
    if (qi && qx) {
      qi.addEventListener('input', function () { qx.hidden = !qi.value; });
      qx.addEventListener('click', function () { qi.value = ''; qx.hidden = true; qi.focus(); });
      qi.closest('form').addEventListener('submit', function (e) { if (!norm(qi.value)) { e.preventDefault(); qi.focus(); } });
    }

    /* forse cerchi · regalo */
    if (q && D.pronto) {
      var rr = righe(q, 2), dl = $('[data-e-rs-dl]', rs), box = $('[data-e-rs-dest]', rs);
      if (dl && rr.length) {
        rr.forEach(function (el) { el.removeAttribute('data-e-cs-opt'); $$('.e-segno', el).forEach(function (s) { s.classList.add('is-drawn'); }); dl.appendChild(el); });
        box.hidden = false;
        dl.addEventListener('click', function (e) {
          var az = e.target.closest('.e-cs__d[data-az]');
          if (az && E.guida && E.guida.apri) { var k = az.getAttribute('data-az') === 'guida-bracciali' ? 'bracciali' : 'anelli'; if (!E.guida.ha || E.guida.ha(k)) { e.preventDefault(); E.guida.apri(k, {}); } }
        });
      }
      var ib = $('[data-e-rs-int]', rs);
      if (ib && intento(q)) ib.hidden = false;
    }

    var grid = $('[data-e-rs-grid]', rs);
    if (!grid) return;
    var dati = {};
    try { dati = JSON.parse(($('[data-e-rs-dati]', rs) || {}).textContent || '{}'); } catch (e) { dati = {}; }
    var T = dati.t || {};
    Object.keys(T).forEach(function (k) { T[k] = dec(T[k]); });
    var TIPI = dati.tipi || {}, FAM = dati.fam || {}, FASCE = (dati.fasce || []).filter(function (f) { return f && f[1]; });
    Object.keys(TIPI).forEach(function (k) { TIPI[k] = dec(TIPI[k]); });
    var ICO = {};
    $$('[data-e-rs-ico] [data-i]', rs).forEach(function (s) { ICO[s.getAttribute('data-i')] = s.innerHTML; });
    var per = +rs.getAttribute('data-per') || 24, ng = +rs.getAttribute('data-ng') || 0;
    var cn = function (n) { return n === 1 ? T.g1 : (T.gn || '').replace('[n]', n); };
    var cap = function (s) { s = String(s || '').trim(); return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; };
    var matLab = function (s) { var d = norm(s); if (d === 'abs') return 'ABS'; if (d === 'technogel') return 'Technogel®'; return cap(String(s).toLowerCase()); };
    var lista = function (s, lab) { return String(s || '').split('|').map(function (x) { return x.trim(); }).filter(Boolean).map(function (x) { return { k: x.toLowerCase(), l: lab(x) }; }); };

    var items = $$('.e-rs__c', grid).map(function (el) {
      return { el: el, tipo: el.getAttribute('data-tipo') || '', mom: el.getAttribute('data-mom') || '', mat: lista(el.getAttribute('data-mat'), matLab), col: lista(el.getAttribute('data-col'), cap), p: +el.getAttribute('data-p') || 0, i: +el.getAttribute('data-i') || 0 };
    });
    var St = { tipo: '', vista: 'g', mom: [], col: [], mat: [], prz: '', sort: 'rel', shown: per };

    function inBand(p, b) {
      var a = String(b).split('-'), lo = a[0] === '' ? -1 : +a[0] * 100, hi = a[1] === '' || a[1] == null ? Infinity : +a[1] * 100;
      return p >= lo && p <= hi;
    }
    function ok(it, skip) {
      if (St.tipo && skip !== 'tipo' && it.tipo !== St.tipo) return false;
      if (St.mom.length && skip !== 'mom' && St.mom.indexOf(it.mom) < 0) return false;
      if (St.col.length && skip !== 'col' && !it.col.some(function (c) { return St.col.indexOf(c.k) > -1; })) return false;
      if (St.mat.length && skip !== 'mat' && !it.mat.some(function (c) { return St.mat.indexOf(c.k) > -1; })) return false;
      if (St.prz && skip !== 'prz' && !inBand(it.p, St.prz)) return false;
      return true;
    }
    /* i valori di ogni filtro, con i numeri calcolati sugli altri filtri */
    function valori(dim) {
      var base = items.filter(function (it) { return ok(it, dim); }), m = {}, ord = [];
      var add = function (k, l, extra) { if (!k) return; if (!m[k]) { m[k] = { k: k, l: l, n: 0, x: extra }; ord.push(m[k]); } m[k].n++; };
      base.forEach(function (it) {
        if (dim === 'tipo') add(it.tipo, TIPI[it.tipo] || cap(it.tipo));
        else if (dim === 'mom') add(it.mom, it.mom, FAM[it.mom]);
        else if (dim === 'col') it.col.forEach(function (c) { add(c.k, c.l); });
        else if (dim === 'mat') it.mat.forEach(function (c) { add(c.k, c.l); });
      });
      if (dim === 'prz') return FASCE.map(function (f) { return { k: f[1], l: f[0], n: base.filter(function (it) { return inBand(it.p, f[1]); }).length }; });
      if (dim === 'mom') { var o = Object.keys(FAM); ord.sort(function (a, b) { return o.indexOf(a.k) - o.indexOf(b.k); }); }
      else ord.sort(function (a, b) { return b.n - a.n || a.l.localeCompare(b.l); });
      return { tot: base.length, v: ord };
    }

    /* barra: schede per tipo */
    function schede() {
      var v = valori('tipo'), html = '';
      var on = function (x) { return x ? 'true' : 'false'; };
      html += '<button class="e-cs__chip" type="button" data-rs-tipo="" aria-pressed="' + on(St.vista === 'g' && !St.tipo) + '">' + esc(T.tutti) + ' <span>' + v.tot + '</span></button>';
      v.v.forEach(function (x) { html += '<button class="e-cs__chip" type="button" data-rs-tipo="' + esc(x.k) + '" aria-pressed="' + on(St.vista === 'g' && St.tipo === x.k) + '">' + esc(x.l) + ' <span>' + x.n + '</span></button>'; });
      if (ng > 0) html += '<button class="e-cs__chip" type="button" data-rs-vista="p" aria-pressed="' + on(St.vista === 'p') + '">' + esc(T.pagine) + ' <span>' + ng + '</span></button>';
      var af = document.activeElement, box = af && af.closest ? af.closest('[data-e-rs-tipi]') : null;
      var fk = box ? (af.hasAttribute('data-rs-vista') ? '[data-rs-vista]' : '[data-rs-tipo="' + (window.CSS && CSS.escape ? CSS.escape(af.getAttribute('data-rs-tipo') || '') : af.getAttribute('data-rs-tipo')) + '"]') : '';
      $$('[data-e-rs-tipi]', rs).forEach(function (c) { c.innerHTML = html; });
      if (box && fk) { var nb = $(fk, box); if (nb) nb.focus({ preventScroll: true }); }
    }

    /* filtri: costruiti una volta, poi si aggiornano numeri e spunte */
    var fb = $('[data-e-rs-fb]', rs), DIMS = [];
    [['mom', T.f_mom], ['col', T.f_col], ['prz', T.f_prz], ['mat', T.f_mat]].forEach(function (d) {
      var v = valori(d[0]);
      var vv = d[0] === 'prz' ? v : v.v;
      var utili = vv.filter(function (x) { return x.n > 0; }).length;
      if (utili < (d[0] === 'mom' ? 1 : 2)) return;
      DIMS.push(d[0]);
      var tipo = d[0] === 'prz' ? 'radio' : 'checkbox';
      var h = '<div class="e-fb" data-e-fb="' + d[0] + '"><button class="e-fb__b" type="button" aria-expanded="false" data-e-fb-btn><span class="e-fb__t">' + esc(d[1]) + '</span><span class="e-fb__n">0</span>' + (ICO.down || '') + '</button>';
      h += '<div class="e-fp' + (vv.length > 8 ? ' e-fp--cols' : '') + '" role="group" aria-label="' + esc(d[1]) + '">';
      vv.forEach(function (x) {
        var sg = d[0] === 'mom' && x.x ? (ICO['seg-' + x.x] || '') : '';
        h += '<label class="e-opt"><input type="' + tipo + '" name="rs-' + d[0] + '" value="' + esc(x.k) + '" data-f="' + d[0] + '"><span class="e-opt__bx">' + (ICO.check || '') + '</span><span>' + sg + esc(x.l) + '</span><span class="e-opt__c">' + x.n + '</span></label>';
      });
      h += '</div></div>';
      fb.insertAdjacentHTML('beforeend', h);
    });
    fb.insertAdjacentHTML('beforeend', (DIMS.length ? '<span class="e-tb__sep" aria-hidden="true"></span>' : '') +
      '<div class="e-fb e-fb--sort" data-e-fb="sort"><button class="e-fb__b" type="button" aria-expanded="false" data-e-fb-btn><span class="e-fb__t">' + esc(T.ordina) + '<span class="e-fb__sl" data-rs-sl></span></span>' + (ICO.down || '') + '</button>' +
      '<div class="e-fp" role="group" aria-label="' + esc(T.ordina) + '">' +
      [['rel', T.s_rel], ['asc', T.s_asc], ['desc', T.s_desc]].map(function (s) { return '<label class="e-opt"><input type="radio" name="rs-sort" value="' + s[0] + '" data-f="sort"' + (s[0] === 'rel' ? ' checked' : '') + '><span class="e-opt__bx">' + (ICO.check || '') + '</span><span>' + esc(s[1]) + '</span><span></span></label>'; }).join('') +
      '</div></div>');

    function sync() {
      DIMS.forEach(function (d) {
        var v = valori(d), vv = d === 'prz' ? v : v.v, m = {};
        vv.forEach(function (x) { m[x.k] = x.n; });
        var sel = d === 'prz' ? (St.prz ? [St.prz] : []) : St[d];
        $$('input[data-f="' + d + '"]', fb).forEach(function (inp) {
          var n = m[inp.value] || 0, on = sel.indexOf(inp.value) > -1;
          inp.checked = on;
          inp.disabled = n === 0 && !on;
          var l = inp.closest('.e-opt');
          l.classList.toggle('is-zero', n === 0 && !on);
          var c = $('.e-opt__c', l);
          if (c) c.textContent = n;
        });
        var box = $('[data-e-fb="' + d + '"]', fb);
        box.classList.toggle('is-act', sel.length > 0);
        $('.e-fb__n', box).textContent = sel.length;
      });
      var sl = $('[data-rs-sl]', fb);
      if (sl) sl.textContent = St.sort === 'rel' ? '' : ': ' + (St.sort === 'asc' ? T.s_asc : T.s_desc);
    }
    function attivi() {
      var out = [];
      St.mom.forEach(function (k) { out.push(['mom', k, k]); });
      St.col.forEach(function (k) { out.push(['col', k, cap(k)]); });
      if (St.prz) FASCE.forEach(function (f) { if (f[1] === St.prz) out.push(['prz', f[1], f[0]]); });
      St.mat.forEach(function (k) { out.push(['mat', k, matLab(k)]); });
      return out;
    }
    function disegna(focusNuovo) {
      var vis = items.filter(function (it) { return ok(it); });
      vis.sort(function (a, b) { return St.sort === 'asc' ? a.p - b.p || a.i - b.i : St.sort === 'desc' ? b.p - a.p || a.i - b.i : a.i - b.i; });
      var fuori = items.filter(function (it) { return vis.indexOf(it) < 0; });
      var primo = null;
      vis.concat(fuori).forEach(function (it, j) {
        var on = j < vis.length && j < St.shown;
        if (on && it.el.hidden && focusNuovo && !primo) primo = it.el;
        it.el.hidden = !on;
        grid.appendChild(it.el);
      });
      var pag = St.vista === 'p';
      grid.hidden = pag;
      var pg = $('[data-e-rs-pg]', rs);
      if (pg) pg.hidden = !pag;
      var more = $('[data-e-rs-more]', rs);
      if (more) {
        more.hidden = pag || vis.length <= St.shown;
        var n = Math.min(St.shown, vis.length);
        $('[data-e-rs-prog]', more).textContent = (T.prog || '').replace('[n]', n).replace('[tot]', cn(vis.length));
        $('[data-e-rs-bar]', more).style.width = (vis.length ? Math.round(n * 100 / vis.length) : 0) + '%';
      }
      var vz = $('[data-e-rs-vz]', rs);
      if (vz) vz.hidden = pag || vis.length > 0;
      var ct = $('[data-e-rs-count]', rs);
      if (ct) ct.textContent = pag ? T.pagine + ' ' + ng : cn(vis.length);
      var mo = $('[data-e-rs-mostra]', rs);
      if (mo) mo.textContent = (T.mostra || '').replace('[n]', cn(vis.length));
      var at = attivi(), act = $('[data-e-rs-act]', rs);
      if (act) {
        act.innerHTML = at.length ? at.map(function (a) { return '<button class="e-chip" type="button" data-rm="' + a[0] + '" data-v="' + esc(a[1]) + '" aria-label="' + esc((T.togli || '').replace('[f]', a[2])) + '">' + esc(a[2]) + (ICO.close || '') + '</button>'; }).join('') + '<button class="e-act__clr" type="button" data-e-rs-clr-all>' + esc(T.togli_tutto) + '</button>' : '';
        act.hidden = pag;
      }
      var nf = $('[data-e-rs-nf]', rs);
      if (nf) { nf.textContent = at.length; nf.hidden = !at.length; }
      schede();
      sync();
      if (primo) { var a = $('a', primo); if (a) a.focus({ preventScroll: true }); }
    }

    function chiudiFb(except) {
      $$('[data-e-fb].is-open', rs).forEach(function (x) { if (x === except) return; x.classList.remove('is-open'); var b = $('[data-e-fb-btn]', x); if (b) b.setAttribute('aria-expanded', 'false'); });
    }
    var sheet = $('[data-e-rs-fs]', rs), sheetBtn = $('[data-e-rs-fs-open]', rs);
    function apriFoglio() {
      if (!sheet || mqDesk.matches) return;
      sheet.classList.add('is-open');
      sheet.setAttribute('aria-modal', 'true');
      H.classList.add('e-lock', 'e-fs-open');
      if (sheetBtn) sheetBtn.setAttribute('aria-expanded', 'true');
      var x = $('[data-e-rs-fs-close]', sheet);
      if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 60);
    }
    function chiudiFoglio() {
      if (!sheet || !sheet.classList.contains('is-open')) return;
      sheet.classList.remove('is-open');
      sheet.setAttribute('aria-modal', 'false');
      H.classList.remove('e-fs-open');
      if (E.sblocca) E.sblocca(); else H.classList.remove('e-lock');
      if (sheetBtn) { sheetBtn.setAttribute('aria-expanded', 'false'); sheetBtn.focus({ preventScroll: true }); }
    }

    rs.addEventListener('click', function (e) {
      var t = e.target;
      var b = t.closest('[data-e-fb-btn]');
      if (b) {
        var box = b.closest('[data-e-fb]'), op = !box.classList.contains('is-open');
        if (mqDesk.matches) chiudiFb(box);
        box.classList.toggle('is-open', op);
        b.setAttribute('aria-expanded', op ? 'true' : 'false');
        return;
      }
      var tp = t.closest('[data-rs-tipo]');
      if (tp) { St.tipo = tp.getAttribute('data-rs-tipo'); St.vista = 'g'; St.shown = per; disegna(); return; }
      if (t.closest('[data-rs-vista]')) { St.vista = 'p'; disegna(); return; }
      var rm = t.closest('[data-rm]');
      if (rm) {
        var d = rm.getAttribute('data-rm'), v = rm.getAttribute('data-v');
        if (d === 'prz') St.prz = ''; else St[d] = St[d].filter(function (x) { return x !== v; });
        St.shown = per;
        disegna();
        return;
      }
      if (t.closest('[data-e-rs-clr-all]')) { St.mom = []; St.col = []; St.mat = []; St.prz = ''; St.shown = per; disegna(); return; }
      if (t.closest('[data-e-rs-next]')) { St.shown += per; disegna(true); return; }
      if (t.closest('[data-e-rs-fs-open]')) { apriFoglio(); return; }
      if (t.closest('[data-e-rs-fs-close]')) { chiudiFoglio(); return; }
    });
    rs.addEventListener('change', function (e) {
      var inp = e.target, d = inp.getAttribute && inp.getAttribute('data-f');
      if (!d) return;
      if (d === 'sort') St.sort = inp.value;
      else if (d === 'prz') St.prz = inp.checked ? inp.value : '';
      else {
        var a = St[d].filter(function (x) { return x !== inp.value; });
        if (inp.checked) a.push(inp.value);
        St[d] = a;
      }
      St.shown = per;
      disegna();
      if (d === 'prz' || d === 'sort') { if (mqDesk.matches) chiudiFb(); }
    });
    /* una fascia di prezzo si toglie anche cliccandola di nuovo */
    rs.addEventListener('click', function (e) {
      var l = e.target.closest && e.target.closest('.e-opt');
      if (!l) return;
      var inp = $('input[data-f="prz"]', l);
      if (inp && inp.checked && St.prz === inp.value && e.target !== inp) { e.preventDefault(); St.prz = ''; St.shown = per; disegna(); }
    });
    document.addEventListener('click', function (e) {
      if (!mqDesk.matches || !document.body.contains(rs)) return;
      if (!e.target.closest || !e.target.closest('[data-e-fb]')) chiudiFb();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !document.body.contains(rs) || S.open) return;
      var o = $('[data-e-fb].is-open', rs);
      if (o && mqDesk.matches) { chiudiFb(); var b = $('[data-e-fb-btn]', o); if (b) b.focus(); return; }
      chiudiFoglio();
    });
    var tbTop = function () { var hd = $('.e-hd'); if (hd) H.style.setProperty('--e-tb-top', hd.offsetHeight + 'px'); };
    tbTop();
    window.addEventListener('resize', tbTop);
    var mqh = function () { chiudiFoglio(); chiudiFb(); };
    if (mqDesk.addEventListener) mqDesk.addEventListener('change', mqh); else if (mqDesk.addListener) mqDesk.addListener(mqh);
    disegna();
  }

  /* ================================================================ avvio, editor di Shopify */
  function init(scope) {
    initPannello(scope);
    initRisultati(scope);
  }
  E.cerca = {
    apri: function () { apri(); },
    chiudi: function () { chiudi(); },
    trova: trova,
    completa: completa,
    intento: intento,
    prezzo: prezzo
  };
  E.hooks = E.hooks || [];
  E.hooks.push(init);
  document.addEventListener('shopify:section:unload', function (e) {
    if (CS && e.target.contains(CS)) { chiudi(true); CS = null; D.pronto = false; }
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (CS && e.target.contains(CS)) apri();
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    if (CS && e.target.contains(CS)) chiudi(true);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
